webpackJsonp([7],{

/***/ "./src/app/data/screenshots/macau/home2.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home2.fb30bcac.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/macau/news_economy.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/news_economy.2acfa579.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/macau/news_people.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/news_people.ad0d7a28.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/macau/videos.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/videos.adbda954.jpg";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/work/macau-news.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__("./node_modules/rebass/dist/index.js");
	
	var _Details = __webpack_require__("./src/Details/index.js");
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _link = __webpack_require__("./src/app/components/link/index.js");
	
	var _link2 = _interopRequireDefault(_link);
	
	var _slider = __webpack_require__("./src/app/components/slider/index.js");
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _Lead = __webpack_require__("./src/Lead/index.js");
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	var _home = __webpack_require__("./src/app/data/screenshots/macau/home2.jpg");
	
	var _home2 = _interopRequireDefault(_home);
	
	var _news_economy = __webpack_require__("./src/app/data/screenshots/macau/news_economy.jpg");
	
	var _news_economy2 = _interopRequireDefault(_news_economy);
	
	var _news_people = __webpack_require__("./src/app/data/screenshots/macau/news_people.jpg");
	
	var _news_people2 = _interopRequireDefault(_news_people);
	
	var _videos = __webpack_require__("./src/app/data/screenshots/macau/videos.jpg");
	
	var _videos2 = _interopRequireDefault(_videos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = [{
	  src: _home2.default,
	  alt: 'Macau News home page'
	}, {
	  src: _news_economy2.default,
	  alt: 'Macau News category page - economy'
	}, {
	  src: _videos2.default,
	  alt: 'Macau News videos page'
	}, {
	  src: _news_people2.default,
	  alt: 'Macau News category page - people'
	}];
	
	var tags = ['Blog', 'Design', 'Wordpress', 'Javascript', 'CSS'];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Details2.default,
	      {
	        title: 'Macau News',
	        subtitle: 'Media'
	      },
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\uD83C\uDDF2\uD83C\uDDF4', title: 'A leading media company in Macau' },
	        _react2.default.createElement(
	          _link2.default,
	          { target: '_blank', href: 'https://macaunews.mo/' },
	          'Macau News'
	        ),
	        ' is a leading local media publisher, that reports on the latest news in Macau. They focus on publishing original content and covering key stories and events happening in the city of Macau.'
	      ),
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\u2764\uFE0F', title: 'Back to basics' },
	        'Macau News wanted a website that allows them to deliver news as efficient as possible. They needed it to be simple; stripped to the essentials of publishing stories and media. Our approach adheres to well-established patterns in website and UI design, and is sync with the readers expectations. The end result is a clean and easy to navigate blog, that is focused on the content.'
	      ),
	      _react2.default.createElement(_Details2.default.Tags, { tags: tags }),
	      _react2.default.createElement(_slider2.default, { images: images }),
	      _react2.default.createElement(
	        _rebass.Box,
	        { mt: 5 },
	        _react2.default.createElement(_Lead2.default, null)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-work-macau-news-js-6c4ea671c7b3ef7cc090.js